import { usePropertyRentalUnitsIncomeRestricted } from '../../../../../../queries/PropertyFields/RentalUnitsFields';
import { ApplicationQuestionReviewItem } from '../../../../../components/ApplicationQuestionReviewItem';
import { DropDownBox } from '@apply/components';
import { useState, useEffect } from 'react';

interface RentalIncomeRestrictedUnitsDropDownProps {
    propertyGuid: string;
    numberOfUnits: number | undefined;
    isReview?: boolean;
}

export const RentalIncomeRestrictedUnitsDropDown: React.FC<RentalIncomeRestrictedUnitsDropDownProps> = ({
    propertyGuid,
    numberOfUnits,
    isReview = false,
}) => {
    const label = 'Units subject to income restricted federal, state, or local housing program';
    const [unitsIncomeRestricted, set_unitsIncomeRestricted] = usePropertyRentalUnitsIncomeRestricted(propertyGuid);
    const [numberIncomeRestrictedUnitsValues, set_numberIncomeRestrictedUnitsValues] =
        useState<{ display: string; value: number | undefined }[]>();

    useEffect(() => {
        if (!numberOfUnits) return;

        const numberList: { display: string; value: number | undefined }[] = [{ display: '', value: undefined }];

        for (let i = 0; i <= numberOfUnits; i++) {
            numberList.push({ display: i.toString(), value: i });
        }

        set_numberIncomeRestrictedUnitsValues(numberList);
    }, [numberOfUnits]);

    const handleNonRentalUnitsIncomeRestricted = (newvalue: number) => {
        if (newvalue == 0) {
            set_unitsIncomeRestricted(0);
        } else {
            const result = newvalue || undefined;
            set_unitsIncomeRestricted(result);
        }
    };

    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={unitsIncomeRestricted}
                />
            ) : (
                <DropDownBox
                    id='incomeRestrictedUnitsValues'
                    value={unitsIncomeRestricted}
                    onChange={(value) => handleNonRentalUnitsIncomeRestricted(value)}
                    label={label}
                    required={true}
                    dataSource={numberIncomeRestrictedUnitsValues}
                    valueExpr='value'
                    displayExpr='display'
                />
            )}
        </>
    );
};
